module.exports = __webpack_public_path__ + "img/sent-email-green.5d20e84e.svg";